import React from 'react';
import Cookies from 'js-cookie';

const CookiePolicyPage = () => {
  const consent = Cookies.get('cookie_consent');
  const consentId = Cookies.get('cookie_consent_id');
  const consentDate = Cookies.get('cookie_consent_date');
  const preferencesCookie = Cookies.get('cookie_preferences');

  // Парсим JSON из 'cookie_preferences'
  let preferences = {};
  if (preferencesCookie) {
    try {
      preferences = JSON.parse(preferencesCookie);
    } catch (error) {
      preferences = {};
    }
  }

  // Определяем текущее состояние
  let currentState = 'Unknown';
  if (consent === 'all') {
    currentState = 'Allow all';
  } else if (consent === 'necessary') {
    currentState = 'Necessary only';
  } else if (consent === 'custom') {
    currentState = 'Custom settings';
  }

  // Преобразуем дату согласия в удобочитаемый формат
  const formattedDate = consentDate
    ? new Date(consentDate).toLocaleString()
    : 'No date';

  // При клике на "Change your consent" — диспатчим событие, которое поймает CookieConsentModal
  const handleChangeConsent = () => {
    window.dispatchEvent(
      new CustomEvent('openConsentModal', {
        detail: { showCustomize: true },
      })
    );
  };

  // Полный отказ (withdraw) — ставим "necessary"
  const handleWithdrawConsent = () => {
    Cookies.set('cookie_consent', 'necessary', { expires: 365 });
    Cookies.set(
      'cookie_preferences',
      JSON.stringify({
        necessary: true,
        analytics: false,
        marketing: false,
      }),
      { expires: 365 }
    );
    window.location.reload();
  };

  return (
    <div className="container mx-auto px-4 my-8">
      <h1 className="text-2xl font-semibold mb-4">Cookie Policy</h1>

      <p className="mb-2">This website uses cookies.</p>
      <p className="mb-2">
        Essential cookies are set automatically. Optional cookies can be adjusted to your preferences. 
      </p>
      <p className="mb-2">
        For more information about our cookie practices please visit our{' '} 
        <a
          href="https://nifty-art.com/privacy"
          className="underline text-violet-600 hover:text-violet-500"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a> 
        
         {' '}or contact us at{' '}
        <a href="mailto:info@nifty-art.com" className="text-violet-600 underline">
          info@nifty-art.com
        </a>.
      </p>

      <p className="mb-2">Your consent applies to the following domains: nifty-art.com</p>
      
      <p className="mb-2">
        Your current state: <span className="font-medium">{currentState}</span>
      </p>
      {consentId && (
        <p className="mb-2">
          Your consent ID: <span className="font-medium">{consentId}</span>
        </p>
      )}
      <p className="mb-2">
        Consent date: <span className="font-medium">{formattedDate}</span>
      </p>

      <div className="flex gap-4 mb-4 mt-4">
        <button 
          onClick={handleChangeConsent} 
          className="text-sm text-violet-600 underline hover:no-underline"
        >
          Change your consent
        </button>
        <button 
          onClick={handleWithdrawConsent} 
          className="text-sm text-violet-600 underline hover:no-underline"
        >
          Withdraw your consent
        </button>
      </div>

      <p className="mb-4">
        Cookie declaration last updated on <span className="font-medium">20.01.2025</span> 
      </p>

      <h2 className="text-xl font-semibold mb-2">Necessary (1)</h2>
      <p className="mb-2">
        Necessary cookies help make a website usable by enabling basic functions like page navigation and 
        access to secure areas of the website. The website cannot function properly without these cookies.
      </p>

      <table className="w-full mb-8 border text-sm border-slate-200 dark:border-slate-700">
        <thead>
          <tr className="border-b bg-gray-50 dark:bg-slate-800">
            <th className="p-2 text-left">Name</th>
            <th className="p-2 text-left">Provider</th>
            <th className="p-2 text-left">Purpose</th>
            <th className="p-2 text-left">Max Duration</th>
            <th className="p-2 text-left">Type</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-b">
            <td className="p-2">CookieConsent</td>
            <td className="p-2">nifty-art.com</td>
            <td className="p-2">
              Stores the user's cookie consent state for the current domain
            </td>
            <td className="p-2">1 year</td>
            <td className="p-2">HTTP Cookie</td>
          </tr>
        </tbody>
      </table>

      <h2 className="text-xl font-semibold mb-2">Statistics (2)</h2>
      <p className="mb-2">
        Statistic cookies help website owners to understand how visitors interact with websites by 
        collecting and reporting information anonymously.
      </p>

      <table className="w-full mb-4 border text-sm border-slate-200 dark:border-slate-700">
        <thead>
          <tr className="border-b bg-gray-50 dark:bg-slate-800">
            <th className="p-2 text-left">Name</th>
            <th className="p-2 text-left">Provider</th>
            <th className="p-2 text-left">Purpose</th>
            <th className="p-2 text-left">Max Duration</th>
            <th className="p-2 text-left">Type</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-b">
            <td className="p-2">_ga</td>
            <td className="p-2">Google</td>
            <td className="p-2">
              Used to send data to Google Analytics about the visitor's device and behavior. 
              Tracks the visitor across devices and marketing channels.
            </td>
            <td className="p-2">2 years</td>
            <td className="p-2">HTTP Cookie</td>
          </tr>
          <tr>
            <td className="p-2">_ga_#</td>
            <td className="p-2">Google</td>
            <td className="p-2">
              Used to send data to Google Analytics about the visitor's device and behavior. 
              Tracks the visitor across devices and marketing channels.
            </td>
            <td className="p-2">2 years</td>
            <td className="p-2">HTTP Cookie</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CookiePolicyPage;
